// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOperationsFilterHideCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.177 5.77c.208-.26.43-.511.662-.75L18.98 19.16l-.061.06A9.966 9.966 0 0 1 12 22C6.477 22 2 17.523 2 12c0-2.355.814-4.52 2.177-6.23zm7.758 7.759H8.5a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h1.935l-1.5-1.5H6.5a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h.935L5.602 7.196a8 8 0 0 0 11.201 11.201zm5.565-4.5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-5.178l-1.5-1.5zm-2 3a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-.178l-1.5-1.5zM12 4a7.964 7.964 0 0 0-4.69 1.518L5.883 4.089A9.957 9.957 0 0 1 12 2c5.523 0 10 4.477 10 10 0 2.304-.78 4.427-2.09 6.118l-1.428-1.429A8 8 0 0 0 12 4zm-1 12.529a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgOperationsFilterHideCircle;
